import React from 'react'
import Cookies from "universal-cookie"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import { domain } from './urls'

const cookies = new Cookies()

const logout = () => {
  cookies.remove("auth_token", { path: "/", domain: domain });
  cookies.remove("user_role", { path: "/", domain: domain });
  window.location.reload();
};

const Header = () => {
  return (
  <Navbar className="" collapseOnSelect expand="lg" variant="dark" style={{background:"#045e92"}}>
    <Navbar.Brand className="d-flex align-items-center" href="/">
      <img src="https://uniacco.imgix.net/site-static/white_logo.svg" className="img-fluid col px-0" alt="uniacco logo" />
      <span className="mt-2 ml-2">Partner</span>
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav" className="d-lg-flex align-items-end">
      <Nav>
        <Nav.Link href="/">Leads</Nav.Link>
        <Nav.Link href="https://crm.uniacco.com" target="_blank">View on CRM</Nav.Link>
        <Nav.Link onClick={logout}>Logout</Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
  );
}


export default Header;